export const getBaseUrl = (): string => `https://${window.location.host}`
